var render = function render(){var _vm=this,_c=_vm._self._c;return _c('widget',{attrs:{"title":"Checklists","icon":"fa-check-square"}},[_c('checklist-table',{attrs:{"hide-edit":false,"hide-delete":false,"resource":"Checklist"},model:{value:(_vm.checklists),callback:function ($$v) {_vm.checklists=$$v},expression:"checklists"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }